class GlobalResponseOption {
  id: number
  label: string
  color: string
  score: number
  failed: boolean
  rate: number
  deleted_at: string | null
  label_translations: Array<string>

  constructor(data: Partial<GlobalResponseOption> = {}) {
    this.id = Number(data?.id ?? 0)
    this.label = String(data?.label ?? "")
    this.color = String(data?.color ?? "")
    this.score = Number(data?.score ?? 0)
    this.failed = Boolean(data?.failed ?? false)
    this.rate = Number(data?.rate ?? 0)
    this.deleted_at = data?.deleted_at ?? null
    this.label_translations = Array.isArray(data?.label_translations)
      ? data.label_translations
      : []
  }
}

class GlobalResponseUser {
  id: number
  first_name: string
  last_name: string
  nick_name: string
  deleted_at: string | null
  full_name: string

  constructor(data: Partial<GlobalResponseUser> = {}) {
    this.id = Number(data?.id ?? 0)
    this.first_name = String(data?.first_name ?? "")
    this.last_name = String(data?.last_name ?? "")
    this.nick_name = String(data?.nick_name ?? "")
    this.deleted_at = data?.deleted_at ?? null
    this.full_name = String(data?.full_name ?? "")
  }
}

class GlobalResponseSetVm {
  uuid: string
  updated_at: string
  deleted_at: string | null
  options: Array<GlobalResponseOption>
  user: GlobalResponseUser | null

  constructor(data: Partial<GlobalResponseSetVm> = {}) {
    this.uuid = String(data?.uuid ?? "")
    this.updated_at = String(data?.updated_at ?? "")
    this.deleted_at = data?.deleted_at ?? null
    this.options = Array.isArray(data?.options)
      ? data.options.map((o) => new GlobalResponseOption(o))
      : []
    this.user = data?.user ? new GlobalResponseUser(data.user) : null
  }
}


type GlobalResponseSetsVm = Record<string, GlobalResponseSetVm>

export { GlobalResponseSetVm, GlobalResponseOption, GlobalResponseUser }
export type { GlobalResponseSetsVm }